import React from 'react'
import { Props } from 'react-select'
import { DefaultSearchPagination } from '../../constants/pagination'
import { useFetchInfiniteTags } from '../../pages/Events/pages/ManageEvents/hooks/useFetchTags'
import { SearchableCreateMultiStringSelect } from '../SearchableSelect/SearchableSelect'

interface TagOptionType {
  value: string
  label: React.JSX.Element | string
  disabled?: boolean
}

type UsedKeys = 'inputId' | 'name' | 'placeholder' | 'onBlur' | 'isDisabled' | 'isLoading'
interface IProps extends Pick<Props<TagOptionType, true>, UsedKeys> {
  values?: string[]
  programId: string
  hasError?: boolean
  onChange: (values: string[]) => void | Promise<void>
}

export const EventTagSelect = (selectProps: IProps) => {
  const { values = [], programId, hasError = false, onChange: handleSelect, ...props } = selectProps
  const searchValues = useFetchInfiniteTags({
    programId,
    fetchProps: {
      query: {
        exclude_value: values,
      },
    },
    pagination: DefaultSearchPagination,
  })

  return (
    <SearchableCreateMultiStringSelect
      {...props}
      values={{ data: values, isLoading: false }}
      itemName="tags"
      searchValues={searchValues}
      hasError={hasError}
      onSelect={(val) => {
        handleSelect(val.filter(Boolean))
      }}
    />
  )
}
